import { createContext } from 'react'
import type { LinkFunction, LinkLocalProps } from '../utilities'

export type SettingsNavConfig = {
	organizationLinker: LinkFunction<LinkLocalProps>
	membersLinker: LinkFunction<LinkLocalProps>
	privacyLinker: LinkFunction<LinkLocalProps>
	campaignSettingsLinker: LinkFunction<LinkLocalProps>
	candidateCenterLinker: LinkFunction<LinkLocalProps>
	exportLinker: LinkFunction<LinkLocalProps>
	customFieldLinker: LinkFunction<LinkLocalProps>
	brandingLibraryLinker: LinkFunction<LinkLocalProps>
	assetHubLinker: LinkFunction<LinkLocalProps>
	inventoryLinker: LinkFunction<LinkLocalProps>
	invoicesLinker: LinkFunction<LinkLocalProps>
	walletLinker: LinkFunction<LinkLocalProps>
	billingLinker: LinkFunction<LinkLocalProps>
	whatsappLinker: LinkFunction<LinkLocalProps>
	emailTemplatesLinker: LinkFunction<LinkLocalProps>
	fontsLinker: LinkFunction<LinkLocalProps>
	designSimulatorLinker: LinkFunction<LinkLocalProps>
	adDesignsLinker: LinkFunction<LinkLocalProps>
	externalConnectionsLinker: LinkFunction<LinkLocalProps>
	careerSiteLinker: LinkFunction<LinkLocalProps>
	aiSettingsLinker: LinkFunction<LinkLocalProps>
}

export type ProvidedSettingsNavConfigContextType = SettingsNavConfig

export const ProvidedSettingsNavConfigContext = createContext<ProvidedSettingsNavConfigContextType>({
	organizationLinker: () => null,
	membersLinker: () => null,
	privacyLinker: () => null,
	campaignSettingsLinker: () => null,
	candidateCenterLinker: () => null,
	exportLinker: () => null,
	customFieldLinker: () => null,
	brandingLibraryLinker: () => null,
	assetHubLinker: () => null,
	inventoryLinker: () => null,
	invoicesLinker: () => null,
	walletLinker: () => null,
	billingLinker: () => null,
	whatsappLinker: () => null,
	emailTemplatesLinker: () => null,
	fontsLinker: () => null,
	designSimulatorLinker: () => null,
	adDesignsLinker: () => null,
	externalConnectionsLinker: () => null,
	careerSiteLinker: () => null,
	aiSettingsLinker: () => null,
})
